import Head from 'next/head';
import Logo from '../public/images/newSVG/logo.svg';
import PlayIco from '../public/investLanding/play-circle.svg';
import TgWhite from '../public/investLanding/tgWhite.svg';
import Land from '../public/investLanding/land.svg';
import Users from '../public/investLanding/users.svg';
import UsersAlt from '../public/investLanding/users-alt.svg';
import Cart from '../public/investLanding/cart.svg';
import Bank from '../public/investLanding/bank.svg';
import File from '../public/investLanding/file.svg';
import Coins from '../public/investLanding/coins.svg';
import Lexa from '../public/investLanding/lexa.svg';
import Graph1 from '../public/investLanding/graph1.svg';
import Graph2 from '../public/investLanding/graph2.svg';
import Graph3 from '../public/investLanding/graph3.svg';
import Graph2Mobile from '../public/investLanding/graph2-mobile.svg';
import Graph1Mobile from '../public/investLanding/graph1-mobile.svg';
import Graph3Mobile from '../public/investLanding/graph3-mobile.svg';
import Andrey from '../public/investLanding/andrey.svg';
import X from '../public/investLanding/x.svg';
import LogoAndText from '../public/investLanding/logo_and_text.svg';
import styles from '../styles/pages/InvestLanding.module.scss';
import localFont from 'next/font/local';
// @ts-ignore
import { useScroll, useMotionValueEvent, motion, useAnimation } from 'framer-motion';
import { FormEvent, useEffect, useState } from 'react';
import clsx from 'clsx';
import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useMutation } from '@apollo/client';
import { NEW_INVEST_LEAD } from '../api/public/lead';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FormField, FormikPhoneInput } from '../components';
import Image from 'next/image';
import invest_preview from '../public/investLanding/invest_preview.webp';
import invest_preview_blur from '../public/investLanding/invest_preview_blur.jpg';
import { FormikTextField } from '../components/inputs/FormikTextField/FormikTextField';

const robo = localFont({ src: '../public/investLanding/RobotoFlex-Regular.ttf' });
const geistMeduim = localFont({ src: '../public/investLanding/Geist-Medium.woff2' });
const geistRegular = localFont({ src: '../public/investLanding/Geist-Regular.woff2' });

const REQUIRED = 'Обязательное поле';

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required(REQUIRED),
  // eslint-disable-next-line
  email: Yup.string().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Некорректная почта'),
  phone: Yup.string().min(17, 'Некорректный телефон').required(REQUIRED),
  telegram: Yup.string(),
  preferredContact: Yup.string().required('Выберете способ связи'),
  clubCard: Yup.string().required('Выберете тип карты'),
  city: Yup.string(),
  investmentVolume: Yup.number(),
  referal: Yup.string(),
  privacyAccepted: Yup.boolean().oneOf([true], 'Необходимо принять условие обработки персональных данных'),
  subscriptionAccepted: Yup.boolean().oneOf([true], 'Необходимо принять участие в закрытой подписке')
});

const SHARES_PACKS = [
  { 'name': 'Карта "Базовая"', cost: 'Стоимость 10 000 руб.', dop: ['Все активности Сообщества','+ 20 акций ENSYS X200'] },
  { 'name': 'Карта "Амбассадор"', cost: 'Стоимость 50 000 руб.', dop: ['Все активности Сообщества','+ 100 акций ENSYS', '+ 3 года подписки на ENSYS AI', '+ Мерч ENSYS X200'] },
  { 'name': 'Карта "Золотая"', cost: 'Стоимость 150 000 руб.', dop: ['Все активности Сообщества','+ 300 акций ENSYS', '+ 5 лет подписки на ENSYS AI', '+ Мерч ENSYS X200'] },
  { 'name': 'Карта "Тим Лидера"', cost: 'Стоимость Бесплатно', dop: ['Все активности Сообщества','+ Возможность строить команды и партннёрский маркетинг'] },
];

const InvestLanding = () => {
  const { scrollY } = useScroll();
  const headerAnimate = useAnimation();
  const headerHrAnimate = useAnimation();
  const [isModalOpen, setIsModalOpen] = useState<boolean | null>(false);
  const [menuActive, setMenuActive] = useState(false);
  const [show, setShow] = useState(false);

  const searchParams = useSearchParams();

  let isScrolled = false;
// @ts-ignore
  useMotionValueEvent(scrollY, "change", (latest) => {
    if (latest > 100) {
      headerAnimate.set({ background: '#ffff', borderRadius: '0px 0px 12px 12px', paddingBottom: '0px', boxShadow: '0px 5px 15px rgba(0,0,0,0.2)' });
      headerHrAnimate.set({ visibility: 'hidden' });
    } else {
      headerAnimate.set({ background: '', borderRadius: '0px', paddingBottom: '15px', boxShadow: 'none' });
      headerHrAnimate.set({ visibility: 'visible' });
    }
    const scrollPercentage = (document.documentElement.scrollTop + window.innerHeight) / document.documentElement.scrollHeight * 100;
    //@ts-ignore
    if (window.ym && !isScrolled && scrollPercentage >= 75) {
      //@ts-ignore
      ym(96603341, 'reachGoal', 'scroll75');
      isScrolled = true;
    }
  });

  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetElement = document.querySelector((e.target as HTMLAnchorElement).getAttribute('href')!);
        const offsetTop = targetElement!.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: offsetTop + -200,
          behavior: 'smooth'
        });
      });
    });
  }, []);

  function isElementInViewport(el: any) {
    const rect = el.getBoundingClientRect();

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const elementTop = rect.top + (rect.height / 2);

    return elementTop >= 0 && elementTop <= viewportHeight;
  }

  useEffect(() => {
    function handleScrollAnimation() {
      const elements = document.querySelectorAll('.animated');
      elements.forEach((element) => {
        if (isElementInViewport(element)) {
          element.classList.add(styles.animatedFromRight);
        }
      });
    }

    window.addEventListener('scroll', handleScrollAnimation);

    return () => window.removeEventListener('scroll', handleScrollAnimation);
  }, []);


  const keydownHandler = (e: any) => {
    if (e.key === 'Escape') {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keydownHandler);
    return () => document.removeEventListener('keydown', keydownHandler);
  });

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const [newLead, { loading, called }] = useMutation(NEW_INVEST_LEAD, {
    onCompleted() {
      // @ts-ignore
      ym(96603341, 'reachGoal', 'formsend');
    },
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      phone: '',
      email: '',
      investmentVolume: '',
      city: '',
      telegram: '',
      preferredContact: '',
      clubCard: '',
      referal: '',
      privacyAccepted: false,
      subscriptionAccepted: false,
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      newLead({
        variables: {
          lead: {
            email: values.email,
            name: values.name,
            phone: values.phone,
            city: values.city,
            telegram: values.telegram,
            preferredContact: values.preferredContact,
            // clubCard: values.clubCard,
            investment_volume: Number(values.investmentVolume.replace(/\s+/g, "")) || 0,
            referal: values.referal,
          },
          notes: searchParams.toString()
        }
      });
    },
  });

  const description = 'Инвестируйте от 10 000 ₽ в маркетплейс инженерного оборудования ' +
    'с планируемой дивидендной доходностью от чистой прибыли и пятикратным ростом капитализации по финмодели';

  const preferredContacts = [
    {label: 'Email', value: 'Email'},
    {label: 'Телефон', value: 'Phone'},
    {label: 'Telegram', value: 'Telegram'}
  ];

  const clubCard = [
    {label: 'Базовая карта', value: 'basic'},
    {label: 'Амбассадор карта', value: 'ambasador'},
    {label: 'Золотая карта', value: 'gold'},
    {label: 'Карта Тим Лидера', value: 'teamlead'}
  ];

  return (
    <div style={{ maxWidth: '1440px', margin: 'auto', position: 'relative', ...robo.style }}>
      <Head>
        <title itemProp="headline">Инвестируйте в маркетплейс инженерного оборудования</title>
        <link rel="canonical" href="https://ensys.store/invest" />

        <meta name="description" content={description} />

        <meta property="og:url" content="https://ensys.store/invest" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Инвестируйте в маркетплейс инженерного оборудования" />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/opengraph.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="ensys.store" />
        <meta property="twitter:url" content="https://ensys.store/invest" />
        <meta name="twitter:title" content="Инвестируйте в маркетплейс инженерного оборудования" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/opengraph.png" />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin='use-credentials' />
        {/* eslint-disable-next-line @next/next/no-page-custom-font */}
        <link href="https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,wght@8..144,100..1000&display=swap" rel="stylesheet" />
      </Head>
      <Script
        id="ya-metrika"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
            (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
        
            ym(96603341, "init", {
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true,
              webvisor:true
            });
        `,
        }}
      />
      {isModalOpen === false &&
        // @ts-ignore
        <div onClick={() => ym(96603341,'reachGoal','openvideo_widget')} className={styles.videoWidget}>
          <X onClick={() => setIsModalOpen(null)} />
          <Image placeholder='blur' blurDataURL={invest_preview_blur.src} onClick={() => setIsModalOpen(true)} src={invest_preview.src} fill alt='' />
        </div>
      }
      {isModalOpen === true &&
        <div className={styles.videoModal} onClick={() => setIsModalOpen(false)}>
          <div>
          <iframe width="720" height="405" src="https://rutube.ru/play/embed/510746cc240c5aa491284b571c2ed82c/?p=FD9WYw43v4OZCISuQKvs9g" frameBorder="0" allow="clipboard-write; autoplay" allowFullScreen></iframe>
            <span><X onClick={() => setIsModalOpen(null)} /></span>
          </div>
        </div>
      }
      <span className={styles.lines} aria-hidden="true"></span>
      <span className={styles.lines2} aria-hidden="true"></span>
      <span className={styles.lines3} aria-hidden="true"></span>
      <span className={styles.lines4} aria-hidden="true"></span>
      <span className={styles.lines5} aria-hidden="true"></span>
      <motion.header animate={headerAnimate} className={styles.header}>
        <nav>
          <Logo />
          {/* @ts-ignore */}
          <button onClick={() => { setShow(true); ym(96603341, 'reachGoal', 'formopen_all'); ym(96603341, 'reachGoal', 'formopen_header') }} className={clsx(styles.mainBtn, styles.hideOnTablet, styles.hideOnDesktop, styles.showOnMobile)}>Оставить заявку</button>
          <div role='button' onClick={() => setMenuActive(!menuActive)} className={clsx(styles.hamburger, menuActive && styles.active)}>
            <div className={clsx(styles.bar, styles.top)}></div>
            <div className={clsx(styles.bar, styles.middle)}></div>
            <div className={clsx(styles.bar, styles.bottom)}></div>
          </div>
          <ul className={clsx(styles.listNav, menuActive && styles.active)}>
            <div className={clsx(styles.backDrop, styles.hideOnTablet, styles.showOnMobile, menuActive && styles.menuOpen, styles.hideOnDesktop)}></div>
            <li><a onClick={() => setMenuActive(false)} href="#about">Об ENSYS</a></li>
            <li><a onClick={() => setMenuActive(false)} href="#factorsSuccess">Факторы успеха</a></li>
            <li><a onClick={() => setMenuActive(false)} href="#metrics">Метрики</a></li>
            <li><a onClick={() => setMenuActive(false)} href="#clubCards">Клубная карта</a></li>
            <li><a onClick={() => setMenuActive(false)} href="#contacts">Контакты</a></li>
          </ul>
          <ul className={styles.listBtns}>
            {/* @ts-ignore */}
            {/* <li><a onClick={() => ym(96603341,'reachGoal','tg_header')} className={styles.tgBtn} target='_blank' href='https://t.me/+HSa7YuQ04m5iZGMy'><Tg /></a></li> */}
            <li><button onClick={() => {
              setShow(true);
              // @ts-ignore
              ym(96603341, 'reachGoal', 'formopen_all'); ym(96603341, 'reachGoal', 'formopen_header');
            }} className={styles.mainBtn}>Оставить заявку</button></li>
          </ul>
        </nav>
        <motion.hr animate={headerHrAnimate} />
      </motion.header>
      <main className={clsx(styles.main)}>
        <div>
          <h1 className={styles.h1} style={geistMeduim.style}>
            Станьте частью сообщества ENSYS X200, которое меняет будущее и зарабатывайте на этом
          </h1>
          <section>
            <h2 className={styles.h2g} style={geistMeduim.style}>
              Венчурные фонды и капиталисты зарабатывают миллиарды на новых технологиях, а обычным людям это не доступно. 
              Наша миссия сделать венчурные инвестиции доступными обычным людям. 
              Это даст возможность заработать каждому и ускорить развитие инноваций в стране и мире.
            </h2>
            {/* @ts-ignore */}
            <button onClick={() => { setShow(true); ym(96603341, 'reachGoal', 'formopen_1') }} style={{ marginTop: '40px' }} className={styles.mainBtn}>Оставить заявку</button>
          </section>
        </div>
        <div className={styles.beginningImage}>
          <div />
        </div>
      </main>
      <div className={clsx(styles.container, styles.shareContainer)}>
        <div  className={styles.shareText}>
          <p>
          Создание сложной технологии - Специального Искусственного Интеллекта для строителей, требует значительных ресурсов. Учитывая слабое венчурное финансирование в России, мы решили построить сообщество людей, поддерживающих цифровизацию строительства и развитие технологий.
          </p>
          <p>
Вступайте в Сообщество ENSYS X200, получите ранний доступ к инновационным разработкам и возможность заработать на этом.
          <p></p>
Часть средств от продаж клубных карт идут на разработку технологии ENSYS. С разными активностями Сообщества, вы также участвуете в краудинвестинге – это означает, что каждый становится совладельцем компании и новой технологии ENSYS, получая дивиденды от чистой прибыли и зарабатывая на капитализации компании.
</p>
        </div>
        <div className={styles.sharePacks} id="clubCards">
          {SHARES_PACKS.map((pack, i) => (
            <div className={styles.sharePack} key={i}>
              {/* <div className={styles.sharePackNum}>
                {`Инвест продукт № ${i+1}`}
              </div> */}
              <div className={styles.sharePackName}>
                <div>{pack.name}</div>
                <div className={styles.sharePackCost}>{pack.cost}</div>
              </div>
              <div className={styles.sharePackDop}>
                {pack.dop.map((dop, idx) => <p key={idx}>{dop}</p>)}
              </div>
              <div className={styles.shareCardContainer}>
                <div>
                  {/* <Image src="/investLanding/x200.png" alt="x200" width="120" height="120" /> */}
                </div>
              </div>
              <div className={styles.sharePackBtn}>
                <button onClick={() => {
                  setShow(true);
                  // @ts-ignore
                  ym(96603341, 'reachGoal', 'formopen_all');
                }} className={styles.mainBtn}>
                  Приобрести
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={clsx(styles.container1)}>
        <section style={{ ...geistMeduim.style }} className={styles.section}>
          <h2 id='about' className={styles.h2}>Об ENSYS</h2>
          <div>
            <h3 className={styles.h3g} style={{ ...geistMeduim.style }}>
              ENSYS.STORE — это не просто очередной строительный маркетплейс в России. Мы создаем Специальный Искусственный Интеллект для строительной отрасли – это экосистема умных агентов на отраслевой языковой модели, обученной только на строительных данных, которая исключает галлюцинации, ошибки и коллизии.
            </h3>
            <button
              onClick={() => {
                // @ts-ignore
                ym(96603341, 'reachGoal', 'openvideo_button');
                setIsModalOpen(true);
              }}
              className={styles.mainBtn}>
              <PlayIco /> Смотреть видео о проекте
            </button>
          </div>
        </section>
        <div>
          <section className={clsx(styles.blockSection)}>
            <h3 style={geistMeduim.style} className={styles.h3}>От 15 заявок<br /> ежедневно</h3>
            <p className={styles.p} style={geistRegular.style}>
              Ежедневно на маркетплейсе ENSYS
              строительные компании размещают<br className={styles.hideOnMobile} />
              <em> от 15 заявок</em> на материалы<br className={styles.hideOnMobile} />
              и оборудование на сумму<br className={styles.hideOnMobile} /> <em>более 5 млн. руб. </em>
              и получают <br className={styles.hideOnMobile} /> предложения от нескольких
              сотен поставщиков в течение нескольких минут. <strong>Сокращая до 80% времени при помощи ИИ</strong>.
            </p>
          </section>
          <section className={clsx(styles.blockSection)}>
            <h3 style={geistMeduim.style} className={styles.h3}>Специальный искусственный интеллект для строительной отрасли</h3>
            <p className={clsx(styles.p, styles.pSmall)} style={geistRegular.style}>
              Мы разработали специализированный ИИ, который уже помогает подобрать стройматериалы по техническим характеристикам. Наша компания зарабатывает 10% от каждого заказа. А в будущем наш ИИ будет работать с BIM-моделями, цифровыми двойниками зданий, создавать проектные и рабочие документации, исключая ошибки. Он сможет общаться с людьми, управлять строительными роботами и предсказыватрь проблемы до их появления. Это сделает строительство быстрее, дешевле и безопаснее.
            </p>
          </section>
          <section className={clsx(styles.blockSection, styles.blockSectionBig)}>
            <h3 style={geistMeduim.style} className={styles.h3}>Более 500 поставщиков <br className={clsx(styles.hideOnTablet)} />и 1600 покупателей</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <p className={styles.p} style={geistRegular.style}>
                Уже зарегистрированы на нашей площадке. Это всего лишь 0,5% от строительного рынка страны. Ближайшие 5 лет цифровизация строительства будет расти огромными темпами. Вы тоже можете стать частью проекта ENSYS и заработать на этом.
              </p>
              {/* @ts-ignore */}
              <button onClick={() => { setShow(true); ym(96603341, 'reachGoal', 'formopen_2') }} className={styles.mainBtn}>Оставить заявку</button>
            </div>
          </section>
        </div>
      </div>
      <div className={clsx(styles.container2, 'animated')}>
        <div className={styles.head1}>
          <h2 className={styles.h2} style={{ ...geistMeduim.style, marginBottom: 0 }}>Как сейчас</h2>
        </div>
        <div className={styles.head2}>
          <h3 style={geistMeduim.style} className={styles.h3g}>Проект запущен в 2022 году на Дальнем Востоке, <br className={styles.hideOnTablet} />как локальный строительный маркетплейс.</h3>
        </div>
        <h3 className={styles.h3} style={{ ...geistMeduim.style, height: '200px', display: 'flex', alignItems: 'flex-end' }}>За 4 года <br /> существования <br /> проекта:</h3>
        <section className={styles.blockSectionSmall}>
          <Land />
          <p className={styles.p} style={geistRegular.style}>Количество регионов работы маркетплейса за год выросло</p>
          <h3 className={styles.h3} style={geistMeduim.style}>с 22 до 67</h3>
        </section>
        <div className={styles.spacer1}></div>
        <section className={styles.blockSectionSmall}>
          <Users />
          <p className={styles.p} style={geistRegular.style}>Рост базы клиентов</p>
          <h3 className={styles.h3} style={geistMeduim.style}>на 30%<br /> каждый месяц</h3>
        </section>
        <section className={clsx(styles.blockSectionSmall, styles.blockBig)}>
          <Cart />
          <p style={geistMeduim.style} className={styles.megaH}>1 200 000</p>
          <p className={styles.p} style={geistRegular.style}>Товарных позиций на маркетплейсе</p>
        </section>
        <section className={styles.blockSectionSmall}>
          <Bank />
          <p className={styles.p} style={geistRegular.style}>В 2023 году привлекли первый раунд инвестиций по оценке</p>
          <h3 className={styles.h3} style={geistMeduim.style}>100 млн. рублей</h3>
        </section>
        <section className={styles.blockSectionSmall}>
          <Coins />
          <p className={styles.p} style={geistRegular.style}>Текущая оценка компании выросла в 5 раз</p>
          <h3 className={styles.h3} style={geistMeduim.style}>со 100 млн. рублей <br />до 515 млн. рублей</h3>
        </section>
        <div className={styles.spacer1}></div>
        <section className={clsx(styles.blockSectionSmall, styles.hideOnTablet)}>
          <UsersAlt />
          <p className={styles.p} style={geistRegular.style}>Количество пользователей <br /> за 2025 год выросло</p>
          <h3 className={styles.h3} style={geistMeduim.style}>в 5 раз: <br className={styles.brSpacer} /> до 481 поставщика <br /> и 1610 покупателей</h3>
        </section>
        <section className={clsx(styles.blockSectionSmall, styles.hideOnTablet, styles.blockBig)}>
          <File />
          <p className={styles.p} style={geistRegular.style}>Количество заявок в месяц за 2025 год выросло</p>
          <p style={{...geistMeduim.style, marginTop: 0}} className={styles.megaH}>в 3,25 раза</p>
        </section>
      </div>
      <div className={styles.container2Tablet}>
        <section className={clsx(styles.blockSectionSmall, styles.mobileBig)}>
          <UsersAlt />
          <p className={styles.p} style={geistRegular.style}>Количество пользователей <br /> за 2025 год выросло</p>
          <h3 className={styles.h3} style={geistMeduim.style}>в 5 раз: <br className={styles.brSpacer} /> до 481 поставщика <br /> и 1610 покупателей</h3>
        </section>
        <section className={clsx(styles.blockSectionSmall, styles.mobileRight)}>
          <File />
          <p className={styles.p} style={geistRegular.style}>Количество заявок в месяц за 2025 год выросло</p>
          <p style={{ ...geistMeduim.style, marginTop: 0 }} className={styles.megaH}>в 3,25 раза</p>
        </section>
      </div>

      <h2 id='factorsSuccess' className={clsx(styles.h2, styles.factorsHeader, 'animated')} style={geistMeduim.style}>3 фактора успеха нашего бизнеса</h2>
      <div className={clsx(styles.factorsContainer, 'animated')}>
        <section style={{ gridColumn: 'span 2' }}>
          <div className={styles.heading}>
            <h3 className={styles.h3} style={{ ...geistMeduim.style }}>Огромный рынок</h3>
            <h3 className={styles.h3} style={{ color: '#C9C9C9', ...geistMeduim.style }}>( 1 )</h3>
          </div>
          <div className={styles.tabContent}>
            <div className={styles.factor1}>
              <div>
                <p style={geistRegular.style} className={styles.p}>Объём рынка РФ инженерных материалов составляет <br className={styles.hideOnTablet} /> <em>3,3 трлн. рублей в год</em> (см. схему)</p>
                <p style={geistRegular.style} className={styles.p}>В 2025 году мы сохранили темп роста по ключевым показателям <br className={styles.hideOnTablet} /> 300% в год, и оцениваем что через 7 лет <em>займем 5% рынка</em> <br className={styles.hideOnTablet} />инженерных систем в РФ.</p>
                <p style={geistRegular.style} className={styles.p}>На данный момент строительный рынок очень слабо оцифрован, и <br className={styles.hideOnTablet} />его цифровизация - самый большой тренд на ближайшие 7-10 лет.</p>
              </div>
              <div className={styles.factor1Graph} />
              {/* <Circular className={styles.factor1Graph1} /> */}
              {/* <Circular744 className={styles.factor1Graph2} /> */}
              {/* <Circular390 /> */}
            </div>
          </div>
        </section>
        <section>
          <div className={styles.heading}>
            <h3 className={styles.h3} style={{ ...geistMeduim.style }}>Технология ИИ</h3>
            <h3 className={styles.h3} style={{ color: '#C9C9C9', ...geistMeduim.style }}>( 2 )</h3>
          </div>
          <div className={clsx(styles.tabContent, styles.tabContent1, styles.customGrid)}>
            <div className={clsx(styles.width100)}>
              <div>
                <p style={geistRegular.style} className={styles.p}>
                  Ядро маркетплейса — специализированная нейронная сеть, которая за минуты подбирает необходимые материалы для строительства по техническим характеристикам. Наш ИИ уже сокращает до 80% времени и 15% бюджета на закупку. И в ближайшие 5-7 лет полностью поменяет строительную отрасль, не только в закупках материалов, но и в других строительных процессах.
                </p>
              </div>
            </div>
            <h3 style={{ ...geistMeduim.style, bottom: '30px' }} className={styles.h3}>
              Решаем реальные проблемы на стройке с помощью IT-технологий.
            </h3>
          </div>
        </section>
        <section>
          <div className={styles.heading}>
            <h3 className={styles.h3} style={{ ...geistMeduim.style }}>Опытная команда</h3>
            <h3 className={styles.h3} style={{ color: '#C9C9C9', ...geistMeduim.style }}>( 3 )</h3>
          </div>
          <div className={clsx(styles.tabContent, styles.tabContent2)}>
            <div className={styles.customGrid2}>
              <div style={{ gridRow: 'span 2' }}>
                <p style={geistRegular.style} className={styles.p}>Команда проекта — <em>16 человек:</em> <br className={styles.hideOnTablet} /> разработчики, маркетолог, менеджер продукта, менеджеры <br className={styles.hideOnTablet} /> логистики, продавцы, операторы колл-центра, HR.</p>
              </div>
              <div className={styles.teamContainer}>
                <div>
                  <Andrey />
                  <div className={styles.infoTeam}>
                    <p className={styles.p} style={geistRegular.style}><em>Лепёхин Андрей <br />CEO</em></p>
                    <p className={styles.subtitle} style={geistRegular.style}>Опыт в сфере продаж <br /> и монтажа инженерных <br />систем более 12 лет</p>
                  </div>
                </div>
                <div>
                  <Lexa style={{ minWidth: '95px' }} />
                  <div className={styles.infoTeam}>
                    <p className={styles.p} style={geistRegular.style}><em>Ленский Алексей <br />CTO</em></p>
                    <p className={styles.subtitle} style={geistRegular.style}>Опыт в сфере IТ-разработки веб- и мобильных сервисов для бизнеса более 18 лет</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section id='metrics' className={clsx(styles.metricsTitle, 'animated')}>
        <h2 style={geistMeduim.style} className={styles.h2}>Метрики компании</h2>
        <h3 style={geistMeduim.style} className={styles.h3g}>41% всех заявок — <br /> повторные от старых клиентов</h3>
      </section>
      <div className={clsx(styles.graphsContainer, 'animated')}>
        <div>
          <Graph1 className={styles.hideOnMobile} />
          <Graph1Mobile className={clsx(styles.hideOnDesktop, styles.hideOnTablet, styles.showOnMobile)} />
        </div>
        <div>
          <Graph2 className={styles.hideOnMobile} />
          <Graph2Mobile className={clsx(styles.hideOnDesktop, styles.hideOnTablet, styles.showOnMobile)} />
        </div>
        <div>
          <Graph3 className={styles.hideOnMobile} />
          <Graph3Mobile className={clsx(styles.hideOnDesktop, styles.hideOnTablet, styles.showOnMobile)} />
        </div>
      </div>
      <div id='investors' className={clsx(styles.offerContainer, 'animated')}>
      </div>
      <div style={{ marginTop: '20px' }} className={clsx(styles.offerContainer, 'animated')}>
        <section className={clsx(styles.block, styles.bigBlock)}>
          <h3 style={{ ...geistMeduim.style }} className={styles.h3g}>Стройте вместе с нами нового «единорога» <br className={styles.hideOnTablet} />на строительном рынке. Мы создаём будущее <br className={styles.hideOnTablet} />отрасли. <em>Хотите быть с нами в первых рядах <br className={styles.hideOnTablet} />инноваторов огромной отрасли?</em></h3>
          <ul className={styles.ulList} style={geistRegular.style}>
            <li className={styles.p}>
              Присоединяйтесь      к Сообществу ENSYS X200,      участвуйте в краудинвестинге, получите ранний доступ к инновационным      разработкам и возможность заработать на этом.
            </li>
            <li className={styles.p}>
              Стройте      с нами глобального игрока цифровизации строительной отрасли.
            </li>
            <li className={styles.p}>
              Получите      опыт построения IТ-компании на строительном рынке.
            </li>
          </ul>
        </section>
      </div>
      <div id='contacts' className={clsx(styles.proposalContainer, 'animated')}>
        <section className={styles.blockLightBlue}>
          <h2 style={geistMeduim.style} className={styles.h2}>Оставьте заявку, чтобы получить более подробную информацию о Сообществе ENSYS X200</h2>
          {/* @ts-ignore */}
          <button onClick={() => { setShow(true); ym(96603341, 'reachGoal', 'formopen_footer') }} style={{ ...geistRegular.style }} className={clsx(styles.mainBtn, styles.big)}>Оставить заявку</button>
        </section>
        <section className={styles.block}>
          <h3 style={geistMeduim.style} className={styles.h3}>Подписывайтесь на наш телеграм-канал, <br className={styles.hideOnTablet} />чтобы быть в курсе новостей компании</h3>
          {/* @ts-ignore */}
          <a onClick={() => ym(96603341, 'reachGoal', 'tg_footer')} className={styles.tgBtnBlue} target='_blank' href='https://t.me/+HSa7YuQ04m5iZGMy'><TgWhite /></a>
        </section>
      </div>
      <footer className={styles.footer}>
        <hr />
        <div>
          <LogoAndText />
          <p style={geistRegular.style} className={styles.subtitle}>
            Акционерное общество “Все инженерные системы“ <br />
            ОГРН 1237700747283<br />
            ИНН 9709101220<br />
            КПП 770901001<br />
            Юридический адрес: 109147, город Москва, Марксистская ул., д. 20 стр. 8, помещ. 1/1
          </p>
        </div>
        <hr />
        <div>
          <p style={{ ...geistRegular.style, color: '#505050' }} className={styles.subtitle}>2026. Все права защищены</p>
          <a href='https://ensys.store/info/agreement' target='_blank' style={{ ...geistRegular.style, color: '#505050', textDecoration: 'none' }} className={styles.subtitle}>Политика конфиденциальности</a>
        </div>
      </footer>
      <InvestModal title='Заявка в Сообщество ENSYS X200' isVisible={show} onClose={() => setShow(false)}>
        {!loading && !called ? (
          <form onSubmit={handleSubmit} style={geistRegular.style} className={styles.formModal}>
            <div className={styles.formRow}>
              <div>
                <label><em>*</em> Фамилия Имя Отчество</label>
                <FormikTextField field='name' formik={formik} />
              </div>
              <div>
                <label><em>*</em> Телефон</label>
                <FormikPhoneInput formik={formik} field='phone' />
              </div>
            </div>
            <div className={styles.formRow}>
              <div>
                <label>Почта</label>
                <FormikTextField field='email' formik={formik} />
              </div>
              <div>
                <label>Telegram</label>
                <FormikTextField field='telegram' formik={formik} />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.formModalRadio}>
                <label><em>*</em> Предпочтительный способ связи</label>
                <FormField
                  required
                  error={
                      formik.touched.preferredContact && formik.errors.preferredContact
                      ? String(formik.errors.preferredContact)
                      : undefined
                  }
                >
                  {
                    preferredContacts.map((item) => (
                      <div key={`Contact_${item.value}`} className={styles.radio}>
                        <input
                          id={`radio_contact_${item.value}`}
                          type="radio"
                          name="preferredContact"
                          value={item.value}
                          checked={formik.values.preferredContact === item.value}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor={`radio_contact_${item.value}`}>
                          {item.label}
                        </label>
                      </div>
                    ))
                  }
                </FormField>
              </div>
            </div>
            <div className={styles.formRow}>
              <div>
                <label>Город</label>
                <FormikTextField field='city' formik={formik} />
              </div>
              <div>
                <label>Промокод</label>
                <FormikTextField field='referal' formik={formik} />
              </div>
            </div>
            <div className={styles.formRow}>
              <div>
                {/* <label>Планируемый объём инвестиций</label>
                <FormikTextField field='investmentVolume' formik={formik} /> */}
                <FormField
                  label='Выбор клубной карты'
                  required
                  error={
                      formik.touched.clubCard && formik.errors.clubCard
                      ? String(formik.errors.clubCard)
                      : undefined
                  }
                >
                  {
                    clubCard.map((item) => (
                      <div key={`ClubCard_${item.value}`} className={styles.radio}>
                        <input
                          id={`radio_clubcard_${item.value}`}
                          type="radio"
                          name="clubCard"
                          value={item.value}
                          checked={formik.values.clubCard === item.value}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor={`radio_clubcard_${item.value}`}>
                          {item.label}
                        </label>
                      </div>
                    ))
                  }
                </FormField>
              </div>
            </div>
            <div className={styles.formRow2}>
              <label className={clsx(styles.accept)}>
                <input checked={formik.values.privacyAccepted} onChange={() => formik.setFieldValue('privacyAccepted', !formik.values.privacyAccepted)} disabled={loading} type='checkbox' />
                <p>Даю согласие на <a href='https://ensys.store/info/privacy-policy' target='_blank'>обработку персональных данных</a></p>
              </label>
              {formik.errors.privacyAccepted ? (
                <div style={{ color: 'red' }}>{formik.errors.privacyAccepted}</div>
              ) : null}
              <label className={clsx(styles.accept)}>
                <input checked={formik.values.subscriptionAccepted} onChange={() => formik.setFieldValue('subscriptionAccepted', !formik.values.subscriptionAccepted)} disabled={loading} type='checkbox' />
                <p>Даю согласие на участие в закрытой подписке (статья 39. Федеральный закон от 26.12.1995 N 208-ФЗ)</p>
              </label>
              {formik.errors.subscriptionAccepted ? (
                <div style={{ color: 'red' }}>{formik.errors.subscriptionAccepted}</div>
              ) : null}
            </div>
            <button disabled={loading} type='submit'>Отправить</button>
          </form>
        ) : (
          <div>
            <h4 style={geistMeduim.style}>Благодарим за интерес к проекту!</h4>
            <p style={geistMeduim.style}>Мы свяжемся с Вами ближайшее время, чтобы ответить на все вопросы.</p>
          </div>
        )}
      </InvestModal>
    </div>
  );
};

export default InvestLanding;


const InvestModal = ({ isVisible = false, title, children, footer, onClose }: any) => {
  const keydownHandler = ({ key }: any) => {
    switch (key) {
      case 'Escape':
        onClose();
        break;
      default:
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keydownHandler);
    return () => document.removeEventListener('keydown', keydownHandler);
  });

  return !isVisible ? null : (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalDialog} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 style={geistMeduim.style} className={styles.h3}>{title}</h3>
          <span className={styles.modalClose} onClick={onClose}>
            &times;
          </span>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.modalContent}>{children}</div>
        </div>
        {footer && <div className={styles.modalFooter}>{footer}</div>}
      </div>
    </div>
  );
};
